// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__9Mm1_","inner":"button_inner__QZMhk","label":"button_label__3gHtT","icon":"button_icon__LcCwy"};